import { gql } from "@apollo/client";

export const GET_AGENT_QUERY = gql`
  query GetAgent($tenantId: String!, $agentId: String!) {
    getAgent(tenantId: $tenantId, agentId: $agentId) {
      tenantId
      agentId
      name
      description
      llmModel
      narrativeInstructions
      codeInterpreter
      userInput
      idleSessionTimeout
      actionGroups {
        groupName
        description
        actionType
      }
    }
  }
`;
